import { makeStyles } from '@material-ui/styles'
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
    contentDiv: {
      width: "100%"
    },
    icon: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        '& .MuiSvgIcon-root': {
            marginRight: 5,
        },
    },
    stepCompleted: {
        root : {
            color: 'green'
        }
    },
    layoutContainer: {
      height: 200,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: theme.spacing(2),
      border: "1px dashed",
      borderColor: theme.palette.primary.main,
      position: "relative"
    },
    layoutText: {
      color: tinycolor(theme.palette.background.light)
        .darken()
        .toHexString()
    },
    layoutButtonsRow: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    },
    layoutButton: {
      backgroundColor: theme.palette.background.light,
      width: 125,
      height: 50,
      outline: "none",
      border: "none"
    },
    layoutButtonActive: {
      backgroundColor: tinycolor(theme.palette.background.light)
        .darken()
        .toHexString()
    },
    buttonsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      marginTop: theme.spacing(2)
    },
    notificationCallButton: {
      color: "white",
      marginBottom: theme.spacing(1),
      textTransform: "none"
    },
    codeContainer: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(2)
    },
    codeComponent: {
      flexGrow: 1
    },
    notificationItem: {
      marginTop: theme.spacing(2)
    },
    notificationCloseButton: {
      position: "absolute",
      right: theme.spacing(2)
    },
    toastsContainer: {
      width: "auto",
      marginTop: theme.spacing(6),
      right: 0
    },
    progress: {
      visibility: "hidden"
    },
    notification: {
      display: "flex",
      alignItems: "center",
      background: "transparent",
      boxShadow: "none",
      overflow: "visible"
    },
    searchIcon: {
      color: "rgba(0, 0, 0, 0.23)"
    },
    imgWrap: {
      height: 100,
      overflow: 'hidden',
      borderRadius: 8,
      boxShadow: '0 0 10px 0px #ccc',
      marginRight: 20,
      marginBottom: 20,
      maxWidth: 125,
      position: 'relative'
    },
    galleryWrap: {
      display: 'flex'
    },
    uploadLabel: {
      backgroundColor: tinycolor(theme.palette.primary.main),
      color: '#f4f4f4',
      maxWidth: 220,
      display: 'inline-block',
      borderRadius: 8,
      textAlign: 'center',
      padding: '8px 12px',
      margin: '20px 0'
    },
    deleteImageX: {
      fontSize: 20,
      position: 'absolute',
      top: 5,
      left: 5,
      cursor: 'pointer',
      lineHeight: .5
    },
    formDisplay: {
      padding: '20px 0',
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      right: 0,
    },
    tabContent: {
      marginTop: '20px'
    },
    autocomplete: {
      width: '100%',
      margin: '0 auto',
      padding: '20px 0'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    calendars: {
      paddingBottom: '20px',
      '& > *': {
          minWidth: '350px'
      },
      '& > :first-child': {
        marginRight: '10px'
      }
    },
    error: {
      color: '#f44336 !important',
      borderColor: '#f44336 !important',
    },
    bottomMenu: {
      padding: '20px 16px 0 16px'
    },
    stepper: {
      padding: 0
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    workers: {
      width: '100%'
    },
    leaderControl: {
      width: '100%'
    },
    leaderInput: {
      width: '100%'
    },
    leaderSelect: {
      width: '100%'
    },
    workersInput: {
      width: '100%'
    },
    workersSelect: {
      width: '100%',
      position: 'relative',
      borderRadius: '4px',
      border: '1px solid #C4C4C4',
      minHeight: '56px'
    },
    edit_job_customer_site_div: {
      display: 'inline-flex',
      width: '100%',
      '& > :first-child': {
        marginRight: '10px'
      }
    },
    notificationComponent: {
      paddingRight: theme.spacing(4),
    },
    bold: {
      fontWeight: 'bold'
    },
    twoColWrapper: {
      display: 'grid',
      gridTemplateColumns: '20% 80%',
      gridGap: '10px',
    },
    threeColWrapper: {
      display: 'grid',
      gridTemplateColumns: '30% 10% 60%',
      gridGap: '10px',
    },
    colWrapper: {
      display: 'grid',
      gridGap: '10px',
    },
    gridCol: {
      padding: '2px'
    },
    workerRow: {
      display: 'grid',
      gridTemplateColumns: 'minmax(150px,200px) auto',
      width: '100%',
      '&> *': {
        padding: '5px',
      },
    },
    tableTitle: {
      fontSize: '1.142rem',
      fontWeight: '500',
      lineHeight: '1.6',
      letterSpacing: '0.0075em',
      color: 'black'
    },
    siteAssetsExpiryTitle: {
      display: 'flex',
    },
    updateSelectedTotalButton: {
      marginLeft: 'auto'
    },
    addButton: {
      textDecoration: 'none'
    },
    calculateDiv: {
      textAlign: 'center',
      fontSize: '16px',
      color: 'black',
      whiteSpace: 'nowrap',
    },
    calculate: {
    cursor: 'pointer',
      textDecoration: 'underline',
      color: `${theme.palette.primary.main} !important`,
    },
    tagSingleRowDownload: {
      textAlign: 'center',
      cursor: 'pointer',
      "&:hover": {
        textDecoration: 'underline',
        color: `${theme.palette.primary.main} !important`,
      }
    },
    tagSingleRowNoDownload: {
      textAlign: 'center',
    },
    footerRow: {
      display: 'table-row',
    },
    footerTopRow: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    footerBottomRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '10px',
      marginTop: '8px',
      borderTop: '1px solid rgba(224,224,224,0.6)',
      paddingTop: '8px',
    },
    footerFullCell: {
      padding: '10px 12px !important',
      borderTop: '1px solid rgba(224, 224, 224, 1)',
    },
    footerBar: {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
      width: '100%',
    },
    footerLeft: {
      display: 'flex',
      alignItems: 'center',
      minWidth: '220px',
    },
    footerRightTop: {
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    footerMiddle: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      flexWrap: 'wrap',
      flex: 1,
      minWidth: '320px',
    },
    footerRight: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '8px',
      minWidth: '220px',
      marginLeft: 'auto',
    },
    footerSwitchLabel: {
      color: 'black !important',
      fontWeight: 400,
    },
    estimateButton: {
      textTransform: 'none',
      fontWeight: 500,
    },
    tagTypes: {
      padding: '5px 0',
      minWidth: '300px'
    },
    expandableTagRow: {
      paddingLeft: '3em'
    },
    wrapColTitle: {
      /*width: '32px',*/
      display: 'block'
    }
}))
